import { playbookPlugins } from './playbook/index.js'

export default [...playbookPlugins]
